// src/components/ConfirmationModal.js
import React from 'react';

const Spinner = () => (
    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
);

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, children, isConfirming }) => {
    if (!isOpen) return null;

    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50 p-4"
        >
            <div 
                className="bg-background dark:bg-dark-background text-foreground dark:text-dark-foreground rounded-lg p-6 w-full max-w-md mx-auto shadow-xl text-center"
            >
                <h2 className="text-2xl font-bold mb-4">{title}</h2>
                <div className="text-gray-600 dark:text-gray-300 mb-6">
                    {children}
                </div>
                <div className="flex justify-center space-x-4">
                    <button 
                        onClick={onClose} 
                        className="px-6 py-2 rounded-lg font-bold bg-gray-200 dark:bg-gray-600 hover:opacity-80"
                        disabled={isConfirming}
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={onConfirm} 
                        className="flex justify-center items-center px-6 py-2 rounded-lg font-bold bg-accent dark:bg-dark-accent text-background dark:text-dark-background w-32"
                        disabled={isConfirming}
                    >
                        {isConfirming ? <Spinner /> : 'Confirm'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
